import { Pricesheet } from "src/shared/models/pricesheet.model";

export const PricesheetSerializer = {
  fromJson(json: any): Pricesheet {
    return new Pricesheet(json);
  },

  fromJsonList(json: any[]): Pricesheet[] {
    return json.map((item) => new Pricesheet(item));
  },
};